import { IComponentOptions } from "angular";
import { ThreeRiversMachinesComponentsViewsMainController } from "./controller";

export const vsComponentName = "machinesView";

export const ThreeRiversMachinesComponentsViewsMain: IComponentOptions = {
  controller: ThreeRiversMachinesComponentsViewsMainController,
  controllerAs: "machinesViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    reportGroup: "<",
  },
};
